import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    chatModalOpen: false,
    newChatModalOpen: false,
    selectedUserId: null,
    searchQuery: '',
    statusFilter: 'all', // all, active, unread, read
    sortBy: 'lastMessage', // lastMessage, createdAt, userName
    sortOrder: 'desc', // asc, desc
    isTyping: false,
    typingUsers: [],
    showUserSearch: false,
    userSearchQuery: '',
    userSearchResults: [],
    userSearchLoading: false
};

const stateSlice = createSlice({
    name: 'liveSupport/state',
    initialState,
    reducers: {
        setChatModalOpen: (state, action) => {
            state.chatModalOpen = action.payload;
        },
        setNewChatModalOpen: (state, action) => {
            state.newChatModalOpen = action.payload;
        },
        setSelectedUserId: (state, action) => {
            state.selectedUserId = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        setSortBy: (state, action) => {
            state.sortBy = action.payload;
        },
        setSortOrder: (state, action) => {
            state.sortOrder = action.payload;
        },
        setIsTyping: (state, action) => {
            state.isTyping = action.payload;
        },
        setTypingUsers: (state, action) => {
            state.typingUsers = action.payload;
        },
        addTypingUser: (state, action) => {
            if (!state.typingUsers.includes(action.payload)) {
                state.typingUsers.push(action.payload);
            }
        },
        removeTypingUser: (state, action) => {
            state.typingUsers = state.typingUsers.filter(userId => userId !== action.payload);
        },
        setShowUserSearch: (state, action) => {
            state.showUserSearch = action.payload;
        },
        setUserSearchQuery: (state, action) => {
            state.userSearchQuery = action.payload;
        },
        setUserSearchResults: (state, action) => {
            state.userSearchResults = action.payload;
        },
        setUserSearchLoading: (state, action) => {
            state.userSearchLoading = action.payload;
        },
        resetFilters: (state) => {
            state.searchQuery = '';
            state.statusFilter = 'all';
            state.sortBy = 'lastMessage';
            state.sortOrder = 'desc';
        },
        resetState: (state) => {
            return { ...initialState };
        }
    }
});

export const {
    setChatModalOpen,
    setNewChatModalOpen,
    setSelectedUserId,
    setSearchQuery,
    setStatusFilter,
    setSortBy,
    setSortOrder,
    setIsTyping,
    setTypingUsers,
    addTypingUser,
    removeTypingUser,
    setShowUserSearch,
    setUserSearchQuery,
    setUserSearchResults,
    setUserSearchLoading,
    resetFilters,
    resetState
} = stateSlice.actions;

export default stateSlice.reducer;
